// Angular
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
// Components
import { BaseComponent } from "./views/theme/base/base.component";
import { ErrorPageComponent } from "./views/theme/content/error-page/error-page.component";
import { AuthGuard } from "./auth.guard";
import { HEC_CONSTANTS } from "./utilities/constants";
import { decrypt } from "./utilities/utilityFunctions";
import { AdminGuard } from "./admin.guard";
import { CommonHelper } from "./utilities/common.helper";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { PcdControllerGuard } from "./views/pages/pcd-controller/pcd-controller-guard";
import { PcdAdminGuard } from "./views/pages/pcd-admin/pcd-admin-guard";

// Auth

// const role = this.checkAdminRole() ? 'des-admin' : 'dashboard'
const routes: Routes = [
	{
		path: "auth",
		loadChildren: () =>
			import("../app/views/pages/auth/auth.module").then(
				(m) => m.AuthModule
			),
	},
	{
		path: "online-help",
		loadChildren: () =>
			import("../app/views/pages/online-help/online-help.module").then(
				(m) => m.OnlineHelpModule
			),
		canActivate: [],
	},
	{
		path: "prr",
		loadChildren: () =>
			import("../app/views/pages/prr-webpage/prr-webpage.module").then(
				(m) => m.PrrWebpageModule
			),
		canActivate: [],
	},
	{
		path: "degree-verification",
		loadChildren: () =>
			import(
				"../app/views/pages/foreign-embassy/foreign-embassy.module"
			).then((m) => m.ForeignEmbassyModule),
		//canActivate: [AuthGuard],
	},

	{
		path: "",
		component: BaseComponent,
		children: [
			{
				path: "dashboard",
				loadChildren: () =>
					import(
						"../app/views/pages/dashboard/dashboard.module"
					).then((m) => m.DashboardModule),
				canActivate: [AuthGuard],
			},
			{
				path: "admin-dashboard",
				loadChildren: () =>
					import(
						"../app/views/pages/admin-dashboard/admin-dashboard.module"
					).then((m) => m.AdminDashboardModule),
				canActivate: [AdminGuard],
			},
			{
				path: "des-admin",
				loadChildren: () =>
					import(
						"../app/views/pages/des-admin/des-admin.module"
					).then((m) => m.DesAdminModule),
				canActivate: [AdminGuard],
			},
			{
				path: "das-admin",
				loadChildren: () =>
					import(
						"../app/views/pages/das-admin/das-admin.module"
					).then((m) => m.DasAdminModule),
				canActivate: [AdminGuard],
			},
			{
				path: "tcs",
				loadChildren: () =>
					import(
						"../app/views/pages/courier-tcs/courier-tcs.module"
					).then((m) => m.CourierTcsModule),
				canActivate: [AdminGuard],
			},
			{
				path: "scheduler",
				loadChildren: () =>
					import(
						"../app/views/pages/das-admin-scheduler/das-admin-scheduler.module"
					).then((m) => m.dasAdminSchedulerModule),
				canActivate: [AdminGuard],
			},
			{
				path: "des-teams",
				loadChildren: () =>
					import(
						"../app/views/pages/team-management/team-management.module"
					).then((m) => m.TeamManagementModule),
				canActivate: [AdminGuard],
			},

			{
				path: "des-verification",
				loadChildren: () =>
					import(
						"../app/views/pages/des-verification/des-verification.module"
					).then((m) => m.DesVerificationModule),
				canActivate: [AdminGuard],
			},
			{
				path: "desf-verification",
				loadChildren: () =>
					import(
						"../app/views/pages/des-verification/des-verification.module"
					).then((m) => m.DesVerificationModule),
				canActivate: [AdminGuard],
			},

			{
				path: "degree-verification-services",
				loadChildren: () =>
					import(
						"../app/views/pages/foreign-embassy/foreign-embassy.module"
					).then((m) => m.ForeignEmbassyModule),
				canActivate: [AuthGuard],
			},

			{
				path: "des-reporting",
				loadChildren: () =>
					import(
						"../app/views/pages/des-reporting/des-reporting.module"
					).then((m) => m.DesReportingModule),
				canActivate: [AdminGuard],
			},
			{
				path: "app-scheduling",
				loadChildren: () =>
					import(
						"../app/views/pages/application-scheduling/application-scheduling.module"
					).then((m) => m.ApplicationSchedulingModule),
				canActivate: [AuthGuard],
			},
			{
				path: "app-rescheduling",
				loadChildren: () =>
					import(
						"../app/views/pages/application-scheduling/application-scheduling.module"
					).then((m) => m.ApplicationSchedulingModule),
				canActivate: [AuthGuard],
			},
			{
				path: "payment",
				loadChildren: () =>
					import("../app/views/pages/payment/payment.module").then(
						(m) => m.PaymentModule
					),
				canActivate: [AuthGuard],
			},
			//coursera active route disabled on 2nd November 2022
			//coursera active route disabled on 30th January 2023

			//coursera active route disabled on 6th April 2023
			{
				path: "ecourses",
				loadChildren: () =>
					import("../app/views/pages/ecourses/ecourses.module").then(
						(m) => m.EcoursesModule
					),
				canActivate: [AuthGuard],
			},

			// 16 august 2023 spring authenticate changes

			{
				path: "pcd",
				loadChildren: () =>
					import("../app/views/pages/pcd/pcd.module").then(
						(m) => m.PcdModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "controller",
				loadChildren: () =>
					import(
						"../app/views/pages/pcd-controller/pcd-controller.module"
					).then((m) => m.PcdControllerModule),

				canActivate: [PcdControllerGuard],
			},
			{
				path: "pcd-admin",
				loadChildren: () =>
					import(
						"../app/views/pages/pcd-admin/pcd-admin.module"
					).then((m) => m.PcdAdminModule),

				canActivate: [PcdAdminGuard],
			},
			{
				path: "coursera-admin",
				loadChildren: () =>
					import(
						"../app/views/pages/coursera-admin/coursera-admin.module"
					).then((m) => m.CourseraAdminModule),
				canActivate: [],
			},
		{
			path: "stamp-details",
			loadChildren: () =>
				import(
					"../app/views/pages/stamp/stamp.module"
				).then((m) => m.addLetterModule),
			canActivate: [AuthGuard],
		},
		{
			path: "stamp-stock",
			loadChildren: () =>
				import(
					"../app/views/pages/stamp/stamp.module"
				).then((m) => m.StampStockModule),
			canActivate: [AuthGuard],
		},
		{
			path: "stamp-activate",
			loadChildren: () =>
				import(
					"../app/views/pages/stamp/stamp.module"
				).then((m) => m.StampActivateModule),
			canActivate: [AuthGuard],
		},
			{
				path: "localdes",
				loadChildren: () =>
					import("../app/views/pages/des/des.module").then(
						(m) => m.DesModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "foreigndes",
				loadChildren: () =>
					import("../app/views/pages/des/des.module").then(
						(m) => m.DesModule
					),
				canActivate: [AuthGuard],
			},
			// {
			// 	path: 'madarsades',
			// 	loadChildren: () => import('../app/views/pages/des/des.module').then(m => m.DesModule),
			// 	canActivate: [AuthGuard],

			// },
			{
				path: "das-app",
				loadChildren: () =>
					import("../app/views/pages/das/das.module").then(
						(m) => m.DasModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "app-tracking",
				loadChildren: () =>
					import(
						"../app/views/pages/application-tracking/application-tracking.module"
					).then((m) => m.TrackingModule),
				canActivate: [AuthGuard],
			},
			{
				path: "upload-courier",
				loadChildren: () =>
					import(
						"../app/views/pages/upload-courier/upload-courier.module"
					).then((m) => m.UploadCourierModule),
				canActivate: [AuthGuard],
			},
			{
				path: "authorize-person",
				loadChildren: () =>
					import(
						"../app/views/pages/authorize-person/authorize-person.module"
					).then((m) => m.AuthorizePersonModule),
				canActivate: [AuthGuard],
			},
			// {
			// 	path: "foreign-embassy",
			// 	loadChildren: () =>
			// 		import(
			// 			"../app/views/pages/foreign-embassy/foreign-embassy.module"
			// 		).then((m) => m.ForeignEmbassyModule),
			// 	//canActivate: [AuthGuard],
			// },
			{
				path: "feedback",
				loadChildren: () =>
					import("../app/views/pages/feedback/feedback.module").then(
						(m) => m.FeedbackModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "track-application",
				loadChildren: () =>
					import(
						"../app/views/pages/track-your-application/track-your-application.module"
					).then((m) => m.TrackYourApplicationModule),
				canActivate: [AuthGuard],
			},
			{
				path: "upload-documents",
				loadChildren: () =>
					import(
						"../app/views/pages/upload-additional-documents/upload-additional-documents.module"
					).then((m) => m.UploadAdditionalDocumentsModule),
				canActivate: [AuthGuard],
			},
			{
				path: "notifications",
				loadChildren: () =>
					import(
						"../app/views/pages/notifications-list/notification-list.module"
					).then((m) => m.NotificationListModule),
				canActivate: [AuthGuard],
			},
			{
				path: "des-payment",
				loadChildren: () =>
					import(
						"../app/views/pages/des-challan/des-challan.module"
					).then((m) => m.DesChallanModule),

				canActivate: [AuthGuard],
			},
			{
				path: "desf-payment",
				loadChildren: () =>
					import(
						"../app/views/pages/des-challan/des-challan.module"
					).then((m) => m.DesChallanModule),

				canActivate: [AuthGuard],
			},
			{
				path: "approved-attestation-applicants",
				loadChildren: () =>
					import("../app/views/pages/approve-attestation-applicants/approved-attestation-applicants.module").then((m) => m.ApprovedAttestationApplicantsModule),

				canActivate: [AuthGuard],
			},

			{
				path: "approved-des-applicants",
				loadChildren: () =>
					import("../app/views/pages/approve-des-applicants/approved-des-applicants.module").then((m) => m.ApprovedDesApplicantsModule),

				canActivate: [AuthGuard],
			},
			{
				path: "approved-desf-applicants",
				loadChildren: () =>
					import("../app/views/pages/approve-desf-applicants/approved-desf-applicants.module").then((m) => m.ApprovedDesfApplicantsModule),

				canActivate: [AuthGuard],
			},
			{
				path: "des-templates",
				loadChildren: () =>
					import(
						"../app/views/pages/template-editor/template-editor.module"
					).then((m) => m.TemplateEditorModule),

				canActivate: [AdminGuard],
			},
			{
				path: "add-template",
				loadChildren: () =>
					import(
						"../app/views/pages/add-letter/add-letter.module"
					).then((m) => m.addLetterModule),

				canActivate: [AdminGuard],
			},
			{
				path: "desf-letter",
				loadChildren: () =>
					import(
						"../app/views/pages/desf-final-letter/desf-final-letter.module"
					).then((m) => m.DesfFinalLetterModule),

				canActivate: [AuthGuard],
			},
			{
				path: "des-final-letter",
				loadChildren: () =>
					import(
						"../app/views/pages/des-final-letter/des-final-letter.module"
					).then((m) => m.DesFinalLetterModule),

				canActivate: [AuthGuard],
			},

			{
				path: "desf-third-letter-request",
				loadChildren: () =>
					import(
						"../app/views/pages/desf-third-letter-request/desf-third-letter-request.module"
					).then((m) => m.DesfThirdLetterRequestModule),

				canActivate: [AuthGuard],
			},

			{
				path: "desf-third-letter",
				loadChildren: () =>
					import(
						"../app/views/pages/desf-third-letter/desf-third-letter.module"
					).then((m) => m.DesfThirdLetterModule),

				canActivate: [AuthGuard],
			},

			{
				path: "des-tracking",
				loadChildren: () =>
					import(
						"../app/views/pages/des-app-tracking/des-app-tracking.module"
					).then((m) => m.DesAppTrackingModule),

				canActivate: [AuthGuard],
			},
			{
				path: "desf-tracking",
				loadChildren: () =>
					import(
						"../app/views/pages/des-app-tracking/des-app-tracking.module"
					).then((m) => m.DesAppTrackingModule),

				canActivate: [AuthGuard],
			},
			{
				path: "ufp",
				loadChildren: () =>
					import(
						"../app/views/pages/university-focal-person/university-focal-person.module"
					).then((m) => m.UniversityFocalPersonModule),

				canActivate: [AuthGuard],
			},
			{
				path: "hec-scrutiny",
				loadChildren: () =>
					import(
						"../app/views/pages/hec-scrutiny-officer/hec-scrutiny-officer.module"
					).then((m) => m.HecScrutinyOfficerModule),

				canActivate: [AuthGuard],
			},
			{
				path: "hec-desf-equ-officer",
				loadChildren: () =>
					import(
						"../app/views/pages/hec-desf-equ-officer/hec-desf-equ-officer.module"
					).then((m) => m.HecDesfEquOfficerModule),

				canActivate: [AuthGuard],
			},
			{
				path: "hec-des-equ-officer",
				loadChildren: () =>
					import(
						"../app/views/pages/hec-des-equ-officer/hec-des-equ-officer.module"
					).then((m) => m.HecDesEquOfficerModule),

				canActivate: [AuthGuard],
			},
			{
				path: "attestation-officer",
				loadChildren: () =>
					import(
						"../app/views/pages/attestation-officer/attestation-officer.module"
					).then((m) => m.AttestationOfficerModule),
				canActivate: [AuthGuard],
			},
			{
				path: "verification-officer",
				loadChildren: () =>
					import(
						"../app/views/pages/verification-officer/verification-officer.module"
					).then((m) => m.VerificationOfficerModule),
				canActivate: [AuthGuard],
			},
			{
				path: "profile",
				// canActivate: [AuthGuard],
				loadChildren:
					"../app/views/pages/profile/profile.module#ProfileModule",
			},
			{
				path: "error/403",
				component: ErrorPageComponent,
				data: {
					type: "error-v6",
					code: 403,
					title: "403... Access forbidden",
					desc: "Looks like you don't have permission to access for requested page.<br> Please, contact administrator",
				},
			},
			{ path: "error/:type", component: ErrorPageComponent },
			{ path: "", redirectTo: "dashboard", pathMatch: "full" },
			{ path: "**", redirectTo: "dashboard", pathMatch: "full" },
		],
	},
	{ path: "**", redirectTo: "error/403", pathMatch: "full" },
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { useHash: true })],
	exports: [RouterModule],
	providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
})
export class AppRoutingModule {
	checkAdminRole (): boolean  {
		if(localStorage.getItem('esp-profile-details')){
		let d = JSON.parse(decrypt(localStorage.getItem('esp-profile-details')))
	const roleList = d.getSpRole
	return roleList.some(role => {
		console.log(role,"test role")
		const roleValue = role.role || role[1];
			return (roleValue == HEC_CONSTANTS.UserRoles.ASSISTANT || roleValue == HEC_CONSTANTS.UserRoles.FINANCE
					|| roleValue == HEC_CONSTANTS.UserRoles.AD || roleValue == HEC_CONSTANTS.UserRoles.DD
					|| roleValue == HEC_CONSTANTS.UserRoles.DIR || roleValue == HEC_CONSTANTS.UserRoles.ED)
	});
	}
	}
}
